// employeeFlow.reducer.js

import { SAVE_JOB_DETAILS_SUCCESS } from "./hospitalManagement.type";

const initialState = {
  jobId: null,
};

export default function hospitalManagementReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case SAVE_JOB_DETAILS_SUCCESS:
      return {
        ...state,
        jobId: action.payload?.id,
      };

    case "CLEAR_JOB_ID":
      return {
        ...state,
        jobId: null,
      };

    default:
      return state;
  }
}
